import React, { useState, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import _get from 'lodash/get';
import _Classnames from 'classnames';
import SearchBox from './SearchBox';
import CategoriesList from './CategoriesList';
import TopicsList from './TopicsList';
import FilterContext from './FilterContext';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  popper: {
    zIndex: 999,
    width: 645,
    marginTop: 20,
    borderRadius: 3,
    border: '1px solid #EFEFEF',
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent #fff transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `transparent transparent #fff transparent`,
      },
    },
  },
  smallPopper: {
    width: 300,
  },
  paper: {
    boxShadow: '0 0 41px 0 rgba(0,0,0,0.10)',
    backgroundColor: '#fff',
    paddingBottom: 24,
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  title: {
    padding: '24px 5px 24px 24px',
  },
}));

function SearchTopics() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const [arrowRef, setArrowRef] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    selectedTopic,
    themes,
    searchTopic,
    isSearching,
    filteredTopicsList,
    changeFilter,
    clientDetails,
  } = useContext(FilterContext);
  const topics = _get(themes[selectedCategoryIndex], 'topicsCollection.items');
  const handleClose = event => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const selectTopic = (slug, event, type, id) => {
    setOpen(false);
    changeFilter(slug, event, type, id);
  };
  return (
    <div className={classes.root}>
      <SearchBox
        searchRef={node => setAnchorEl(node)}
        handleFocus={() => setOpen(true)}
        value={selectedTopic}
        searchTopic={searchTopic}
      />
      <Popper
        open={open}
        anchorEl={anchorEl}
        className={_Classnames(
          classes.popper,
          isSearching ? classes.smallPopper : undefined,
        )}
        transition
        placement="bottom-start"
        modifiers={{
          flip: {
            enabled: false,
          },
          arrow: {
            enabled: true,
            element: arrowRef,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'window',
          },
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            id="menu-list-grow"
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <>
              <span className={classes.arrow} ref={setArrowRef} />
              <Paper className={classes.paper}>
                <ClickAwayListener onClickAway={handleClose}>
                  {isSearching ? (
                    <div>
                      <TopicsList
                        topics={filteredTopicsList}
                        selectTopic={selectTopic}
                        isSearching={isSearching}
                      />
                    </div>
                  ) : (
                    <Grid container>
                      <Grid item xs={12} className={classes.title}>
                        <Typography variant="h6" color="primary">
                          All Topics
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container direction="row">
                          <CategoriesList
                            themes={themes}
                            onClick={index => setSelectedCategoryIndex(index)}
                            selected={selectedCategoryIndex}
                            clientDetails={clientDetails}
                          />
                          <TopicsList
                            topics={topics}
                            selectTopic={selectTopic}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </ClickAwayListener>
              </Paper>
            </>
          </Grow>
        )}
      </Popper>
    </div>
  );
}

export default SearchTopics;
